<template>
  <v-container fluid grid-list-xs>

    <v-flex>
      <div class="filter-bar">
        <!-- SELECT PERSON - FILTER -->
        <v-flex ma-2 xs12 sm12 md2 class="align-self-end">
          <v-label>Person</v-label>
          <v-select
            :item-text="getName"
            item-value="email"
            v-model="personEmail"
            :items="getPpl"
            @input="changeSelectedPerson"
            hide-default-footer
            dense
            :disabled="editing"
          ></v-select>
        </v-flex>
        <v-flex ma-2 xs12 sm12 md2 class="align-self-end">
          <v-label>Categories</v-label>
          <v-select
            :items="categories"
            placeholder="All"
            v-model="categoryFilter"
            multiple
            hide-default-footer
            dense
          ></v-select>
        </v-flex>
        <v-flex ma-2 xs12 sm12 md2 class="align-self-end">
          <v-label>Proficiency Level</v-label>
          <v-select
            item-text="value"
            item-value="key"
            placeholder="All"
            v-model="proficiencyFilter"
            :items="proficiencies"
            multiple
            hide-default-footer
            dense
          ></v-select>
        </v-flex>
        <v-flex>
          <v-switch v-model="coreFilter" :label="'Show Core Only'"></v-switch>
        </v-flex>
        <v-btn @click="clearFilter" outlined class="primary--text filter-item">Clear Filters</v-btn>
        <v-btn
          v-if="!editing && (userIsSelected || userIsAdmin)"
          @click="enableEditing()"
          outlined
          class="primary--text filter-item"
        >Manage Skills</v-btn>
        <v-btn
          v-if="editing && (userIsSelected || userIsAdmin)"
          @click="saveSkills()"
          outlined
          class="primary--text filter-item"
        >Save</v-btn>
        <v-btn
          v-if="editing && (userIsSelected || userIsAdmin)"
          @click="editing = false"
          outlined
          class="primary--text filter-item"
        >Cancel</v-btn>
        <v-spacer class="mt-3"></v-spacer>
      </div>
    </v-flex>
    <v-card class="primary">
      <v-card-title>
        <h5 class="title white--text">JG Skills</h5>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          dark
          color="white"
          :append-icon="this.search.length===0? 'search' : 'clear'"
          label="Search by Skill"
          single-line
          hide-default-footer
          v-model="search"
          @click:append="clearSearch"
        ></v-text-field>
      </v-card-title>
    </v-card>
    <v-card>
      <!-- DATA TABLE - VIEW AND EDIT -->
      <v-data-table
        :headers="headers"
        :items="getTechSkillsRatings"
        :search="search"
        :expanded.sync="expanded"
        :single-expand="true"
        item-key="key"
        show-expand
      >      
        <template v-slot:item.Image="{item}">

          <template v-if="item.hasLocalImage">
            <v-img v-bind:src="item.ImageUrl" max-width="5vh"></v-img>
          </template>
          <template v-else>
            <v-img :src="noImg" alt="no image" max-width="5vh"></v-img>
          </template>
        </template>
        <!-- JG Core Competency icon cells -->
        <template v-slot:item.Core="{item}">
          <v-icon v-if="item.Core === 'TRUE'" class="core-icon" color="primary">$jglogo</v-icon>
        </template>
        <!-- Interested cell -->
        <template v-slot:item.Interested="{item}">
          <v-icon v-if="!editing && item.interested" color="primary">check</v-icon>
          <v-checkbox v-if="editing" v-model="skillEdits[item.key].interested"></v-checkbox>
        </template>
        <!-- Header for Rating 0 cell -->
        <template v-slot:header.0Rating="{header}">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="tooltip-header">{{header.text}}</span>
            </template>
            <span>{{proficiencies[1].value}}</span>
          </v-tooltip>
        </template>
        <!-- Rating 0 cell -->
        <template v-slot:item.0Rating="{item}">
          <v-icon v-if="!editing && item.rating === 0" color="primary">check</v-icon>
          <v-radio-group v-if="editing" v-model="skillEdits[item.key].rating">
            <v-radio :value="0"></v-radio>
          </v-radio-group>
        </template>
        <!-- Header for Rating 1 cell -->
        <template v-slot:header.1Rating="{header}">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="tooltip-header">{{header.text}}</span>
            </template>
            <span>{{proficiencies[2].value}}</span>
          </v-tooltip>
        </template>
        <!-- Rating 1 cell -->
        <template v-slot:item.1Rating="{item}">
          <v-icon v-if="!editing && item.rating === 1" color="primary">check</v-icon>
          <v-radio-group v-if="editing" v-model="skillEdits[item.key].rating">
            <v-radio :value="1"></v-radio>
          </v-radio-group>
        </template>
        <!-- Header for Rating 2 cell -->
        <template v-slot:header.2Rating="{header}">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="tooltip-header">{{header.text}}</span>
            </template>
            <span>{{proficiencies[3].value}}</span>
          </v-tooltip>
        </template>
        <!-- Rating 2 cell -->
        <template v-slot:item.2Rating="{item}">
          <v-icon v-if="!editing && item.rating === 2" color="primary">check</v-icon>
          <v-radio-group v-if="editing" v-model="skillEdits[item.key].rating">
            <v-radio :value="2"></v-radio>
          </v-radio-group>
        </template>
        <!-- Header for Rating 3 cell -->
        <template v-slot:header.3Rating="{header}">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="tooltip-header">{{header.text}}</span>
            </template>
            <span>{{proficiencies[4].value}}</span>
          </v-tooltip>
        </template>
        <!-- Rating 3 cell -->
        <template v-slot:item.3Rating="{item}">
          <v-icon v-if="!editing && item.rating === 3" color="primary">check</v-icon>
          <v-radio-group v-if="editing" v-model="skillEdits[item.key].rating">
            <v-radio :value="3"></v-radio>
          </v-radio-group>
        </template>
        <!-- Description expansion panel -->
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">{{item.Description}}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import {
  updateSelectedPersonSkillsRating,
  updatePersonSkillsRating,
  writeSkillsRatingByTechnologyPeopleRatedAt,
} from "@/vue-service-skills";
import { setSelected, getPersonsPushId } from "@/vue-service-selected_person";
import firebase from "firebase";

var defaultImg = require('./no-img.jpg')
export default {
  data() {
    return {
      noImg: defaultImg,
      editing: false,
      skillEdits: {},
      skillInterest: {},
      expanded: [],
      search: "",
      setSearch: true,
      categoryFilter: [],
      proficiencyFilter: [],
      coreFilter: false,
      personEmail: { email: this.$store.getters.person.email },
      proficiencies: [
        { key: -1, value: "--:Not Rated" },
        { key: 0, value: "0:Nothing/Novice" },
        { key: 1, value: "1:Lacking/Inexperienced" },
        { key: 2, value: "2:Confident/Experienced" },
        { key: 3, value: "3:Lead/Teach" },
      ],
      headers: [
        {
          text: "",
          value: "Image",
          width: "5%",
          filterable: false,
          sortable: false,
        },
        {
          text: "Category",
          value: "Category",
          width: "10%",
          filterable: false,
        },
        { text: "Skill", value: "Name", width: "10%", filterable: true },
        {
          text: "JG Core Competency",
          value: "Core",
          width: "5%",
          filterable: false,
          align: "center",
        },
        {
          text: "Interested",
          value: "Interested",
          width: "5%",
          filterable: false,
          align: "center",
        },
        {
          text: "0",
          value: "0Rating",
          width: "5%",
          filterable: false,
          sortable: false,
          align: "center",
        },
        {
          text: "1",
          value: "1Rating",
          width: "5%",
          filterable: false,
          sortable: false,
          align: "center",
        },
        {
          text: "2",
          value: "2Rating",
          width: "5%",
          filterable: false,
          sortable: false,
          align: "center",
        },
        {
          text: "3",
          value: "3Rating",
          width: "5%",
          filterable: false,
          sortable: false,
          align: "center",
        },
        {
          text: "People Ranked",
          value: "Count",
          width: "5%",
          filterable: false,
          align: "center",
        },
        { text: "Website", value: "WebsiteUrl", filterable: false },
      ],
    };
  },
  computed: {
    userIsAdmin() {
      return this.$store.getters.administrator;
    },
    userIsSelected() {
      return this.$store.getters.selectedPersonIsUser;
    },
    // Get tech skills ratings for everything before applying filters
    getAllTechSkillsRatings: function () {
      // Get all of the technologies we know about
      let technologies = this.$store.getters.technology;
      // Get all of the skills the selected person has rated themselves on
      let ratedSkills = this.$store.getters.selectedPersonSkillsRating;
      if (ratedSkills === null) {
        ratedSkills = {};
      }

      // Create an array that contains all of these skills and their keys, but rated
      let skills = Object.keys(technologies).map((key) =>
        Object.assign(
          {
            key: key,
            rating: ratedSkills[key] ? ratedSkills[key].Rating : -1,
            interested: ratedSkills[key]
              ? ratedSkills[key].Interested
                ? true
                : false
              : false,
            changelog: ratedSkills[key]
              ? ratedSkills[key].Changelog
                ? ratedSkills[key].Changelog
                : null
              : null,
          },
          technologies[key]
        )
      );

      return skills;
    },
    updateTechs: function () {
      updateTechnology();
    },

    // Apply filters to the rated skills
    getTechSkillsRatings: function () {
      // Get all skills
      let skills = this.getAllTechSkillsRatings;

      // If we aren't editing, hide unrated skills to keep things clean
      if (!this.editing) {
        skills = skills.filter(
          (skill) =>
            skill.rating !== undefined &&
            (skill.rating > -1 || skill.interested)
        );
      }
      // Apply filters
      if (this.categoryFilter.length !== 0) {
        skills = skills.filter((skill) =>
          this.categoryFilter.includes(skill.Category)
        );
      }
      if (this.proficiencyFilter.length !== 0) {
        skills = skills.filter((skill) =>
          this.proficiencyFilter.includes(skill.rating)
        );
      }
      if (this.coreFilter) {
        skills = skills.filter((skill) => skill.Core === "TRUE");
      }

      return skills;
    },
    getPpl: function () {
      // if the store is not ready, lets get a snapshot for now.
      // const testStore = true;
      // if (testStore){
      if (this.$store.getters.people === null) {
        if (this.personEmail.email === null) {
          this.personEmail = { email: this.$store.getters.person.email };
        }
        var snapShotArray = [];
        const database = firebase.database();
        const peopleRef = database.ref("people").orderByChild("fName");
        peopleRef.once('value', (snapShot)=>{
          snapShot.forEach((item)=>{
            var val = item.val();
            if (val.active) {
              snapShotArray.push(val)
            }
          });
        })
        // console.log("snapShotArray = \n"+JSON.stringify(snapShotArray.map(i=>i.fName+" "+i.lName)));
        return snapShotArray.map((item)=>{
                   let i = item;
          // console.log("Skills.vue, ln 369\ngetPpl\n"+ item.fName+" "+item.lName);
          if (item.email === this.$store.getters.user.email)
            i = Object.assign({}, i, { lName: item.lName + " (me)" });
          return i;
        })
      } else {

      // TODO: This is sorta hacky, there must be a better way
      if (this.personEmail.email === null) {
        this.personEmail = { email: this.$store.getters.person.email };
      }
      let storeValues = [];
      Object.values(this.$store.getters.people)
        .filter(
          (item) => item !== null && item.email && item.lName && item.active
        )
        .map((item) => {
          let i = item;
          // console.log("Skills.vue, ln 369\ngetPpl\n"+ item.fName+" "+item.lName);
          if (item.email === this.$store.getters.user.email)
            i = Object.assign({}, i, { lName: item.lName + " (me)" });
          return i;
        }).forEach(item => {storeValues.push(item);})
        let sorted = storeValues.sort((a, b) => a.fName + a.lName > b.fName + b.lName ? 1:-1);
        // for (const item of sorted) {
        //   console.log("Skills.vue, ln 412\ngetPpl (sorted)\n"+ item.fName+" "+item.lName)
        // }
        return sorted
      }
    },
    categories: function () {
      let tech = this.$store.getters.technology;
      if (tech === null) {
        return [];
      } else {
        return [...new Set(Object.values(tech).map((e) => e.Category))];
      }
    },
  },
  methods: {
    getName: (item) => item.fName + " " + item.lName,
    changeSelectedPerson(email) {
      const key = getPersonsPushId(email);
      setSelected(key);
    },
    clearFilter() {
      this.categoryFilter = [];
      this.proficiencyFilter = [];
      this.coreFilter = false;
    },
    clearSearch() {
      this.search = "";
    },
    enableEditing() {
      this.editing = true;

      // Setup skill edits with all tech skills in case some filters are active when user starts editing
      this.skillEdits = this.getAllTechSkillsRatings.reduce((acc, skill) => {
        acc[skill.key] = {
          rating: skill.rating,
          interested: skill.interested,
          changelog: skill.changelog,
        };
        return acc;
      }, {});
    },
    saveSkills() {
      const oldSkills = this.$store.getters.selectedPersonSkillsRating;
      const techs = this.$store.getters.technology;

      // Filter out skills that have never been rated
      // Reduce current and updated skills to ratings and interest
      const skillsUpdates = Object.keys(this.skillEdits)
        .filter(
          (key) =>
            this.skillEdits[key].rating > 0 ||
            this.skillEdits[key].interested ||
            this.skillEdits[key].changelog !== null
        )
        .reduce((acc, key) => {
          // Get the rating and interest from skillEdits
          acc[key] = {
            Rating: this.skillEdits[key].rating,
            Interested: this.skillEdits[key].interested,
          };

          // Apply all current data from the tech
          let tech = techs[key];
          for (let k in tech) {
            acc[key][k] = tech[k];
          }

          if (oldSkills[key] !== undefined) {
            // If skill was previously rated, get its changelog
            if (oldSkills[key].Changelog !== undefined) {
              // If there are old changelogs, process them to accountSkills for legacy storage and use them
              acc[key].Changelog = this.processOldChangelog(
                oldSkills[key].Changelog
              );
            } else {
              // Legacy - skill was rated before we were logging, so register its current rating with time 0
              acc[key].Changelog = {
                "0": {
                  Rating: oldSkills[key].Rating,
                  Interested: oldSkills[key].Interested ? true : false,
                },
              };
            }
          } else {
            // Otherwise, make a new one (we'll add the new timestamp in the next part)
            acc[key].Changelog = {};
          }
          return acc;
        }, {});

      let timestamp = Date.now().toString();

      // Add new timestamp if something was changed
      for (let key in skillsUpdates) {
        let mostRecentChangeKey = this.getMostRecentKey(skillsUpdates[key]);
        if (mostRecentChangeKey === "-1") {
          // No history in changelog, new rating. Update changelog
          skillsUpdates[key].Changelog[timestamp] = {
            Rating: skillsUpdates[key].Rating,
            Interested: skillsUpdates[key].Interested,
          };
        } else {
          // History in changelog, must check if new change is different
          let currentState = skillsUpdates[key].Changelog[mostRecentChangeKey];
          if (
            currentState.Rating !== skillsUpdates[key].Rating ||
            currentState.Interested !== skillsUpdates[key].Interested
          ) {
            // New change is different. Update changelog
            skillsUpdates[key].Changelog[timestamp] = {
              Rating: skillsUpdates[key].Rating,
              Interested: skillsUpdates[key].Interested,
            };
          }
        }
      }
      updateSelectedPersonSkillsRating(skillsUpdates);
      this.editing = false;
    },
    processOldChangelog(changelog) {
      let cl = {};
      for (let key in changelog) {
        if (changelog[key].Interested === undefined) {
          // If changelog entry existed, but wasn't the new spec, update it
          cl[key] = { Rating: changelog[key], Interested: false };
        } else {
          // Otherwise, it was the new spec, keep it
          cl[key] = changelog[key];
        }
      }
      return cl;
    },
    getMostRecentKey(skill) {
      let mostRecent = "-1";
      for (let key in skill.Changelog) {
        if (parseInt(key) > parseInt(mostRecent)) {
          mostRecent = key;
        }
      }
      return mostRecent;
    },
  },
};
</script>

<style scoped>
.icon-space {
  margin-right: 10px;
  margin-bottom: 0px;
  padding-right: 10px;
  padding-bottom: 0px;
}
.v-input--selection-controls.v-input .v-label {
  display: none;
}
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 1rem;
  border: 1px;
}
.v-input__slot {
  margin-bottom: 0;
}
.filter-bar {
  display: flex;
  justify-content: left;
  align-items: center;
}
.filter-item + .filter-item {
  margin-left: 10px;
}
.tooltip-header {
  padding: 20px;
  margin: -20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Skills/Skills.vue